export default __webpack_public_path__ + "static/media/QR.7c37ff4c.svg";